import { createContext, useCallback, useState } from 'react';

import { getUserSettings, updateSettings } from '@/functions/userSettings';

export type SetRefs = {
  [x: string]: (ref: HTMLAnchorElement) => void;
};

export interface SidebarContextProps {
  isOpen: boolean;
  setSidebar: (isOpen: boolean) => void;
  setRefs: SetRefs;
  notificationsPageRef: HTMLElement | null;
}

const SidebarContext = createContext<SidebarContextProps>(
  {} as SidebarContextProps,
);

export function SidebarProvider(props: any) {
  const userSettings = getUserSettings();
  const sidebarStatus = userSettings?.sidebar;

  const sidebarBooleanStatus = sidebarStatus === 'true';

  const [isOpen, setIsOpen] = useState(sidebarBooleanStatus);

  const setSidebar = useCallback((isOpen: boolean) => {
    setIsOpen(isOpen);
    updateSettings({ updates: { sidebar: String(isOpen) } });
  }, []);

  const [notificationsPageRef, setNotificationsPageRef] =
    useState<HTMLElement | null>(null);

  const setRefs: {
    [key in string]: (ref: HTMLAnchorElement) => void;
  } = {
    sidebarNotifications: setNotificationsPageRef,
  };

  return (
    <SidebarContext.Provider
      value={{
        setSidebar,
        isOpen,
        setRefs,
        notificationsPageRef,
      }}
    >
      {props.children}
    </SidebarContext.Provider>
  );
}

export default SidebarContext;
